let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3aC1N")).then(() => parcelRequire('g31zB'));